import React from "react";
import { connect } from "react-redux";
import {getResponsibleUser} from "../actions/countryActions";
import StyledAsyncSelect from "../../components/common/StyledAsyncSelect";

@connect(
    state => ({
        user: state.auth.user
    }),
    dispatch => ({
        usersData: _ => dispatch(getResponsibleUser()),
    })
)
export default class ResponsibleSelect extends React.Component {
    loadGroupsOptions = async query => {
        let data = await this.props.usersData();
        let options = data.usersData.map(g => ({ label: g.displayName, value: g._id }))
        return {options};
    };
    render() {
        return (
            <StyledAsyncSelect
                ignoreAccents={false}
                placeholder={this.props.default ? this.props.default : "Country"}
                loadOptions={this.loadGroupsOptions}
                {...this.props}
            />
        );
    }
}
